<!--  SOFT ERROR  -->

<div class="written-content padded">
	<p>{{data?.soft_error.message}}</p>
</div>

<!--  END SOFT ERROR  -->
